export default "__VITE_ASSET__D5R9FXPZ__"